import { createSelector } from 'reselect';

import { State } from 'reducers';

import { DonationsSeedState, initialState } from './reducers';
import { KEY } from './constants';

const selectState = (state: State): DonationsSeedState => state.get(KEY) || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));
